/** Keep prefix in sync with backend doctor-lead-source.util.ts */
export const DOCTOR_LEAD_SOURCE_PREFIX = 'DOCTOR_LEAD:';

export function isDoctorLeadSourceKey(value: string | null | undefined): boolean {
  return String(value ?? '').trim().startsWith(DOCTOR_LEAD_SOURCE_PREFIX);
}

export function buildDoctorLeadSourceLabel(teamLeadName: string): string {
  const trimmed = String(teamLeadName ?? '').trim();
  if (!trimmed) return 'Doctor Lead';
  const withPrefix = /^dr\.?\s/i.test(trimmed) ? trimmed : `Dr ${trimmed}`;
  return `${withPrefix} Lead`;
}

export function mergeDoctorLeadSourceOptions(
  base: Array<{ value: string; label: string }>,
  doctorSources?: Array<{ value: string; label: string }>
): Array<{ value: string; label: string }> {
  const map = new Map(base.map((s) => [s.value, s.label] as const));
  for (const d of doctorSources ?? []) {
    if (d.value) map.set(d.value, d.label);
  }
  return Array.from(map.entries())
    .map(([value, label]) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
